interface InitialSbrDateRangeArgs {
    search?: string;
    lastStart?: number;
    lastEnd?: number;
}

function parseRangeValue(value: string | null | undefined): number | null {
    if (!value) {
        return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
}

function createRange(start: number | null, end: number | null) {
    if (start == null || end == null || start >= end) {
        return null;
    }

    return { start, end };
}

export function getInitialSbrDateRange({
    search = '',
    lastStart,
    lastEnd,
}: InitialSbrDateRangeArgs) {
    const params = new URLSearchParams(search);
    const urlRange = createRange(
        parseRangeValue(params.get('start')),
        parseRangeValue(params.get('end'))
    );
    if (urlRange) {
        return urlRange;
    }

    return createRange(lastStart ?? null, lastEnd ?? null);
}
